import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

// Actions & constants
import { sortAppointmentStatusArray } from '../../services/appointmentFilters';
import {
  updateFilterAppointmentsStatus,
  setFilterAppointmentsStatuses
} from '../../reducer/actions';

// Components
import { SelectField } from 'components/Fields';

// Styles & Images
import stfStyles from './styles';
import ListIcon from 'src/assets/images/list-icon-gray.svg';

const renderValueItem = translate()(({ i18n }) => {
  return (
    <stfStyles.ValueItemWrapper>
      <img src={ListIcon} alt="list icon"/>
      <p>{i18n.t('view_appointments')}</p>
    </stfStyles.ValueItemWrapper>
  );
});

class StatusFilter extends Component {
  constructor() {
    super();
    this.renderDropDown = this.renderDropDown.bind(this);
  }

  componentDidMount() {
    // Set appointments statuses
    const { role, selectedAppointmentStatus, setFilterAppointmentsStatuses } = this.props;
    if (!selectedAppointmentStatus && sortAppointmentStatusArray) {
      const prepareArray = [];
      sortAppointmentStatusArray(role).forEach(item => {
        if (item.defaultActive) {
          prepareArray.push(item.conditions);
        }
      });
      setFilterAppointmentsStatuses(prepareArray);
    }
  }

  renderDropDown() {
    const { role, updateFilterAppointmentsStatus, selectedAppointmentStatus, i18n } = this.props;

    const isActive = appoint => {
      if (selectedAppointmentStatus && appoint && appoint.conditions) {
        return selectedAppointmentStatus.some(el => String(el) === String(appoint.conditions));
      }
    };

    return (
      <stfStyles.CustomList>
        {sortAppointmentStatusArray(role).map(filterItem => (
          <stfStyles.CustomItem
            key={filterItem && filterItem.translateLabel}
            onClick={() => {
              if (updateFilterAppointmentsStatus)
                updateFilterAppointmentsStatus(filterItem.conditions);
            }}
            active={isActive(filterItem)}
            bottomLine={filterItem.bottomLine}
          >
            <p>
              {i18n.t(
                filterItem && filterItem.translateLabel && filterItem.translateLabel.toLowerCase()
              )}
            </p>
            <span />
          </stfStyles.CustomItem>
        ))}
      </stfStyles.CustomList>
    );
  }

  render() {
    return (
      <stfStyles.FilterWrapper>
        <SelectField
          valueComponent={renderValueItem}
          messages={{
            emptyList: this.renderDropDown()
          }}
        />
      </stfStyles.FilterWrapper>
    );
  }
}

const mapStateToProps = state => ({
  role: state.auth.role,
  selectedAppointmentStatus: state.practitioner.appointments.filters.selectedAppointmentStatus
});

export default connect(
  mapStateToProps,
  { updateFilterAppointmentsStatus, setFilterAppointmentsStatuses }
)(translate()(StatusFilter));
